var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16.726 14.837h-1l-.347-.345a8.138 8.138 0 001.972-5.316A8.176 8.176 0 009.175 1 8.176 8.176 0 00.999 9.176a8.176 8.176 0 008.176 8.176 8.139 8.139 0 005.314-1.97l.347.345v1l6.287 6.278 1.875-1.875-6.274-6.289zm-7.55 0a5.659 5.659 0 01-5.66-5.66 5.66 5.66 0 015.66-5.66 5.661 5.661 0 015.66 5.66 5.66 5.66 0 01-5.66 5.66z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.79d50442abe73f01625af9002628b451.svg";
export { ForwardRef as ReactComponent };